import React from "react"
import Base  from "./base"

// Components
import Combobox from "@shared/combobox"

// Helpers
import { getRequest }           from '@helpers/javascript/javascript'
import { applyVatRateToLines }  from "@shared/quotes/resolveVatRate"

export default class Site extends Base {
  constructor(props) {
    super(props)
    this.onSelectSite = this.onSelectSite.bind(this)
  }

  onSelectSite(selected) {
    if (!selected?.id) {
      this.props.replaceQuote({...this.props.quote, site: {}, materials: []})
      return
    }

    getRequest(`/quotes/form/${selected.id}/site.json`)
      .then(site => {
        const quote = this.props.quote
        this.deactivate()
        // A quote-wide VAT rate is an explicit choice: it outlives a site
        // change, and the lines forcing their own rate keep it.
        const qlines = quote.vat_rate?.id
          ? applyVatRateToLines(quote.qlines, quote.vat_rate)
          : quote.qlines.map(qline => ({...qline, vat_rate: site.vat_rate}))
        // Equipment belongs to a site: another site means another selection.
        this.props.replaceQuote({...quote, site, qlines, materials: []})
      })
  }

  render() {
    const { quote, replaceQuote } = this.props
    const client = quote.client
    const site   = quote.site

    return(
      this.state.active || !site.id
      ? <div className="form-group">
          <label>{I18n.t("workorders.site")}</label>

          <Combobox
            fieldName       = "quote[site_id]"
            options         = {client.sites || []}
            value           = {site.id}
            disabled        = {!client.id}
            placeholder     = {I18n.t("workorders.select_site")}
            onSelectElement = {this.onSelectSite}
            onReset         = {() => replaceQuote({...quote, site: {}})}
            resetIcon
            required
          />
        </div>
      : <>
          <div className="quotes--form-pointer pb-0" onClick={this.activate}>
            <div className="quotes--form-title">
              {I18n.t("workorder_pdf.site")}
            </div>
            <div>{site.name}</div>
            <div>{site.address}</div>
            <input type="hidden" name="quote[site_id]" defaultValue={quote.site.id} />
          </div>

          { site.modal_url &&
            <div className="client-details">
              <div
                data-toggle = "modal"
                data-target = "#template-modal"
                data-route  = {site.modal_url}
                data-action = "click->client--modal#show"
                className   = "pointer button-link"
              >
                { I18n.t("sites.folder") }
              </div>
            </div>
          }
        </>
    )
  }
}
